import React, {useState, useEffect} from "react";
import Navbar                       from "./Components/Navbar/Navbar";
import Header                       from "./Components/Header/Header";
import Details                      from "./Components/Details/Details";
import About                        from "./Components/About/About";
import Processes                    from "./Components/Processes/Processes";
import Rewards                      from "./Components/Rewards/Rewards";
import Jurors                       from "./Components/Jurors/Jurors";
import Timetables                   from "./Components/Timetables/Timetables";
import Form                         from "./Components/Form/Form";
import FAQ                          from "./Components/FAQ/FAQ";
import Footer                       from "./Components/Footer/Footer";
import Alert                        from "react-popup-alert"
import "./App.css";

const App = () => {
    const smoothScroll = (target) =>{
        const {top} = target.getBoundingClientRect()
        if(target)
        window.scrollTo({
            top:      top - 88 + window.pageYOffset,
            behavior: "smooth"
        });
    }

    useEffect(()=>{
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.scrollTo(0, 0);
        document.documentElement.style.scrollBehavior = "smooth";
    },[])
    
    const [alert, setAlert] = useState({
        type: "warning",
        text: <p style = {{color: "black"}}>"Başvurular sona erdi."</p>,
        show: true,
    })

    const closeAlert = () =>{
        setAlert({
            type: "warning",
            text: <p style = {{color: "black"}}>"Başvurular sona erdi."</p>,
            show: false
        })
    }
    
    return (
        <div className = "App">
            <Navbar  showWarning = {setAlert} scroll = {smoothScroll}/>
            <Header  scroll = {smoothScroll}/>
            <Details scroll = {smoothScroll}/>
            <About/>
            <Processes/>
            <Rewards/>
            <Timetables/>
            <Jurors/>
            <FAQ/>
            <Form showWarning = {setAlert}/>
            <Footer/>
            <Alert header                   = {alert.header}
                   btnText                  = {"Kapat"}
                   text                     = {alert.text}
                   type                     = {alert.type}
                   show                     = {alert.show}
                   onClosePress             = {closeAlert}
                   pressCloseOnOutsideClick = {true}
                   showBorderBottom         = {true}
                   alertStyles              = {{position: "fixed", top: "25vh", left: "0", right: "0", width: `${window.innerWidth>640 ? "50vw" : "80vw"}`, margin: "0 auto", backgroundColor: "white", padding: "32px 32px 64px 32px", borderRadius: "8px", borderBottomColor: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "32px", boxShadow: "0 0 64px rgb(0, 0, 0, .28)", zIndex: "999", maxHeight: `${window.innerWidth>640 ? "35vw" : "72vh"}`, color: "black"}}
                   headerStyles             = {{}}
                   textStyles               = {{fontSize: "2rem", maxWidth: `${window.innerWidth>640 ? "48vw" : "78vw"}`, maxHeight: `${window.innerWidth>640 ? "30vw" : "80vh"}`, overflowY: "auto"}}
                   buttonStyles             = {{fontSize: "1.5rem", color: "white", padding: "10px 18px", borderRadius: "8px"}}/>
        </div>
    );
}

export default App;